export const SERVER_LOADED = 'SERVER_LOADED';
export const CLIENT_LOADED = 'CLIENT_LOADED';
export const PLATFORM_WEB = 'WEB';
